import { z } from 'zod';

export const saveCardSchema = z.object({
  pan: z
    .string({ required_error: 'card_number_required' })
    .min(1, 'card_number_required')
    .refine(val => val.length === 16, 'card_number_required'),
  expiry: z
    .string({ required_error: 'expiry_required' })
    .min(1, 'expiry_required')
    .refine(val => /^\d{2}\/\d{2}$/.test(val), 'expiry_required')
    .refine(val => {
      const [mm, yy] = val.split('/');
      const month = parseInt(mm, 10);
      if (month < 1 || month > 12) return false;
      const year = 2000 + parseInt(yy, 10);
      const now = new Date();
      const expiryDate = new Date(year, month, 0);
      return expiryDate >= now;
    }, 'expiry_invalid'),
  title: z
    .string({ required_error: 'title_required' })
    .min(1, 'title_required'),
});

export const otpSaveCardSchema = z.object({
  otp: z
    .string({ required_error: 'otp_required' })
    .min(1, 'otp_required'),
});
